module.exports = __webpack_public_path__ + "static/media/bvmlogo.c14c5e20.png";